export const ExpandRightIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path d="M20.4997 16L12.4997 24L11.0664 22.5667L17.6664 16L11.0997 9.43333L12.5331 8L20.4997 16Z" fill="black" />
  </svg>
);
